import { render, staticRenderFns } from "./homeDseg.vue?vue&type=template&id=a372be5e&scoped=true"
import script from "./homeDseg.vue?vue&type=script&lang=js"
export * from "./homeDseg.vue?vue&type=script&lang=js"
import style0 from "./homeDseg.vue?vue&type=style&index=0&id=a372be5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a372be5e",
  null
  
)

export default component.exports